export const LAYOUT = {
  SIDEBAR_WIDTH: "300px",
  CONTENT_GAP: 2,
  MAIN_GAP: 3,
  PAPER_PADDING: 3,
  PAPER_MARGIN_TOP: 3,
  CONTAINER_PADDING: 3,
};

export const DEFAULT_DISPLAY_LIMIT = 6;

export const DATA_CLEANING_STEPS = [
  { id: "select-client", label: "Select Client" },
  { id: "select-entity", label: "Select Entity" },
  { id: "select-field", label: "Select Field" },
  { id: "clean-data", label: "Clean Data" },
];
